/**
 * MAINTENANCE PROGRAMS FEATURED PROJECT
 * Last updated: [Date will auto-update when edited]
 * 
 * Update this file to change the maintenance programs featured project.
 */

const maintenanceProject = {
  category: "maintenance",
  title: "A legacy property deserves legacy care.",
  images: {
    topLeft: {
      top: "/images/projects/maintenance/Maintenancefeature3A.jpg",
      bottom: "/images/projects/maintenance/maintenancefeature1A.jpeg",
      topAlt: "Maintenance project finished state",
      bottomAlt: "Maintenance project ongoing care"
    },
    bottomLeft: {
      top: "/images/projects/maintenance/maintenancefeature4A.jpg",
      bottom: "/images/projects/maintenance/Maintenancefeature2A.jpg",
      topAlt: "Maintenance project crew at work",
      bottomAlt: "Maintenance project before care"
    }
  },
  paragraphs: [
    "Condominium communities are a cornerstone of the valley’s charm — and maintaining their grounds means preserving part of the region’s legacy.",
    
    "Our crews manage these landscapes year-round, coordinating closely with local resort operations to deliver quiet, precise, and reliable service that aligns with the area's elevated hospitality standards. From seasonal color rotations to snow season transitions, every detail is timed for a seamless guest experience.",
    
    "Working on such a prominent property is a point of pride for our team; a reflection of the trust we’ve earned . Reliability, discretion, and excellence — that’s the All Seasons difference."
  ]
};

export default maintenanceProject;